import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { getFooterDetails, getInnBusinessHeader, getCardManagementLabels as getCardManagementLabelsQuery, getUserManagementLabels as getUserManagementLabelsQuery, getInnBusinessLayoutLabels as getInnBusinessLayoutLabelsQuery, getProfileManagementLabelsQuery, getCompanyManagementLabelsQuery, getHomepageLabelsQuery, getSpendingLabelsQuery, getAuthLabelsQuery, getPayApplicationLabelsQuery, getNotificationsLabelsQuery, getContactUsLabelsQuery } from '@whitbread-eos/api';
import { executeContentGraphQLQuery } from '../gql';
export var getFooterLabels = function () {
  var _ref = _asyncToGenerator(function* (language) {
    return yield executeContentGraphQLQuery(getFooterDetails(), {
      language,
      country: language === 'en' ? 'gb' : 'de',
      site: 'inn-business'
    }, result => {
      var _result$data;
      return result === null || result === void 0 || (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.footer;
    });
  });
  return function getFooterLabels(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var getInnBusinessHeaderLabels = function () {
  var _ref2 = _asyncToGenerator(function* (language) {
    return yield executeContentGraphQLQuery(getInnBusinessHeader(), {
      language,
      country: language === 'en' ? 'gb' : 'de',
      businessBooker: true
    }, result => {
      var _result$data2;
      return result === null || result === void 0 || (_result$data2 = result.data) === null || _result$data2 === void 0 || (_result$data2 = _result$data2.headerInformation) === null || _result$data2 === void 0 ? void 0 : _result$data2.innBusinessHeader;
    });
  });
  return function getInnBusinessHeaderLabels(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export var getCardManagementLabels = function () {
  var _ref3 = _asyncToGenerator(function* (language) {
    var data = yield executeContentGraphQLQuery(getCardManagementLabelsQuery(), {
      country: language === 'en' ? 'gb' : 'de',
      language
    }, result => {
      var _result$data3;
      return result === null || result === void 0 || (_result$data3 = result.data) === null || _result$data3 === void 0 || (_result$data3 = _result$data3.getPageData) === null || _result$data3 === void 0 ? void 0 : _result$data3.cardManagementEndpoint;
    });
    return data ? JSON.parse(data) : null;
  });
  return function getCardManagementLabels(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
export var getInnBusinessLayoutLabels = function () {
  var _ref4 = _asyncToGenerator(function* (language) {
    var data = yield executeContentGraphQLQuery(getInnBusinessLayoutLabelsQuery(), {
      country: language === 'en' ? 'gb' : 'de',
      language
    }, result => {
      var _result$data4;
      return result === null || result === void 0 || (_result$data4 = result.data) === null || _result$data4 === void 0 || (_result$data4 = _result$data4.getPageData) === null || _result$data4 === void 0 ? void 0 : _result$data4.layoutEndpoint;
    });
    return data ? JSON.parse(data) : null;
  });
  return function getInnBusinessLayoutLabels(_x4) {
    return _ref4.apply(this, arguments);
  };
}();
export var getUserManagementLabels = function () {
  var _ref5 = _asyncToGenerator(function* (language) {
    var data = yield executeContentGraphQLQuery(getUserManagementLabelsQuery(), {
      country: language === 'en' ? 'gb' : 'de',
      language
    }, result => {
      var _result$data5;
      return result === null || result === void 0 || (_result$data5 = result.data) === null || _result$data5 === void 0 || (_result$data5 = _result$data5.getPageData) === null || _result$data5 === void 0 ? void 0 : _result$data5.userManagementEndpoint;
    });
    return data ? JSON.parse(data) : null;
  });
  return function getUserManagementLabels(_x5) {
    return _ref5.apply(this, arguments);
  };
}();
export var getProfileManagementLabels = function () {
  var _ref6 = _asyncToGenerator(function* (language) {
    var data = yield executeContentGraphQLQuery(getProfileManagementLabelsQuery(), {
      country: language === 'en' ? 'gb' : 'de',
      language
    }, result => {
      var _result$data6;
      return result === null || result === void 0 || (_result$data6 = result.data) === null || _result$data6 === void 0 || (_result$data6 = _result$data6.getPageData) === null || _result$data6 === void 0 ? void 0 : _result$data6.profileManagementEndpoint;
    });
    return data ? JSON.parse(data) : null;
  });
  return function getProfileManagementLabels(_x6) {
    return _ref6.apply(this, arguments);
  };
}();
export var getCompanyManagementLabels = function () {
  var _ref7 = _asyncToGenerator(function* (language) {
    var data = yield executeContentGraphQLQuery(getCompanyManagementLabelsQuery(), {
      country: language === 'en' ? 'gb' : 'de',
      language
    }, result => {
      var _result$data7;
      return result === null || result === void 0 || (_result$data7 = result.data) === null || _result$data7 === void 0 || (_result$data7 = _result$data7.getPageData) === null || _result$data7 === void 0 ? void 0 : _result$data7.companyManagementEndpoint;
    });
    return data ? JSON.parse(data) : null;
  });
  return function getCompanyManagementLabels(_x7) {
    return _ref7.apply(this, arguments);
  };
}();
export var getHomepageLabels = function () {
  var _ref8 = _asyncToGenerator(function* (language) {
    var data = yield executeContentGraphQLQuery(getHomepageLabelsQuery(), {
      country: language === 'en' ? 'gb' : 'de',
      language
    }, result => {
      var _result$data8;
      return result === null || result === void 0 || (_result$data8 = result.data) === null || _result$data8 === void 0 || (_result$data8 = _result$data8.getPageData) === null || _result$data8 === void 0 ? void 0 : _result$data8.homepageEndpoint;
    });
    return data ? JSON.parse(data) : null;
  });
  return function getHomepageLabels(_x8) {
    return _ref8.apply(this, arguments);
  };
}();
export var getSpendingLabels = function () {
  var _ref9 = _asyncToGenerator(function* (language) {
    var data = yield executeContentGraphQLQuery(getSpendingLabelsQuery(), {
      country: language === 'en' ? 'gb' : 'de',
      language
    }, result => {
      var _result$data9;
      return result === null || result === void 0 || (_result$data9 = result.data) === null || _result$data9 === void 0 || (_result$data9 = _result$data9.getPageData) === null || _result$data9 === void 0 ? void 0 : _result$data9.spendingReportingEndpoint;
    });
    return data ? JSON.parse(data) : null;
  });
  return function getSpendingLabels(_x9) {
    return _ref9.apply(this, arguments);
  };
}();
export var getAuthLabels = function () {
  var _ref0 = _asyncToGenerator(function* (language) {
    var data = yield executeContentGraphQLQuery(getAuthLabelsQuery(), {
      country: language === 'en' ? 'gb' : 'de',
      language
    }, result => {
      var _result$data0;
      return result === null || result === void 0 || (_result$data0 = result.data) === null || _result$data0 === void 0 || (_result$data0 = _result$data0.getPageData) === null || _result$data0 === void 0 ? void 0 : _result$data0.authEndpoint;
    });
    return data ? JSON.parse(data) : null;
  });
  return function getAuthLabels(_x0) {
    return _ref0.apply(this, arguments);
  };
}();
export var getPayApplicationLabels = function () {
  var _ref1 = _asyncToGenerator(function* (language) {
    var data = yield executeContentGraphQLQuery(getPayApplicationLabelsQuery(), {
      country: language === 'en' ? 'gb' : 'de',
      language
    }, result => {
      var _result$data1;
      return result === null || result === void 0 || (_result$data1 = result.data) === null || _result$data1 === void 0 || (_result$data1 = _result$data1.getPageData) === null || _result$data1 === void 0 ? void 0 : _result$data1.payApplicationEndpoint;
    });
    return data ? JSON.parse(data) : null;
  });
  return function getPayApplicationLabels(_x1) {
    return _ref1.apply(this, arguments);
  };
}();
export var getInitials = (firstName, lastName) => {
  var _firstName$charAt, _lastName$charAt;
  return ((firstName === null || firstName === void 0 || (_firstName$charAt = firstName.charAt(0)) === null || _firstName$charAt === void 0 ? void 0 : _firstName$charAt.toUpperCase()) || '') + ((lastName === null || lastName === void 0 || (_lastName$charAt = lastName.charAt(0)) === null || _lastName$charAt === void 0 ? void 0 : _lastName$charAt.toUpperCase()) || '');
};
export var getNotificationsLabels = function () {
  var _ref10 = _asyncToGenerator(function* (language) {
    var data = yield executeContentGraphQLQuery(getNotificationsLabelsQuery(), {
      country: language === 'en' ? 'gb' : 'de',
      language
    }, result => {
      var _result$data10;
      return result === null || result === void 0 || (_result$data10 = result.data) === null || _result$data10 === void 0 || (_result$data10 = _result$data10.getPageData) === null || _result$data10 === void 0 ? void 0 : _result$data10.notificationsEndpoint;
    });
    return data ? JSON.parse(data) : null;
  });
  return function getNotificationsLabels(_x10) {
    return _ref10.apply(this, arguments);
  };
}();
export var getContactUsLabels = function () {
  var _ref11 = _asyncToGenerator(function* (language) {
    var data = yield executeContentGraphQLQuery(getContactUsLabelsQuery(), {
      country: language === 'en' ? 'gb' : 'de',
      language
    }, result => {
      var _result$data11;
      return result === null || result === void 0 || (_result$data11 = result.data) === null || _result$data11 === void 0 || (_result$data11 = _result$data11.getPageData) === null || _result$data11 === void 0 ? void 0 : _result$data11.innbContactUsEndpoint;
    });
    return data ? JSON.parse(data) : null;
  });
  return function getContactUsLabels(_x11) {
    return _ref11.apply(this, arguments);
  };
}();